export default {
  'debug': process.env.DEBUG,
  'infiniteScroll': false,
  'staticBaseUrl': process.env.STATIC_BASE_URL,
  'api': {
    'baseUrl': process.env.API_BASE_URL
  },
  'routerApi': {
    'baseUrl': process.env.ROUTER_API_BASE_URL
  },
  // Servicio de direcciones (MOOV-5539): revisión de direcciones con IA vía review/{clean,match,confidence}.
  'addresses': {
    'baseUrl': process.env.ADDRESS_SERVICE_BASE_URL
  },
  // Fallback de platform-information cuando la API principal falla.
  'meliApi': {
    'baseUrl': process.env.MELI_API_BASE_URL,
    'apiKey': process.env.MELI_API_KEY
  },
  geo: {
    check: 'https://geoip.maxmind.com/geoip/v2.1/country/me',
    account: '775290',
    key: 'B08h7Wv2cGX0kwUA'
  },
  'auth': {
    'google': {
      'clientId': '996521258982-0mpmitvdpb2drggpros1qdf7c216rses.apps.googleusercontent.com'
    },
    'facebook': {
      'clientId': '357701778300515'
    }
  },
  flexCutOutHour: 15,
  'helpdocs_BAK': {
    'baseUrl': 'https://api.helpdocs.io/v1/',
    'api_key': '25qudf023lhz4aun2fyko3skj82h6e9p8n87uxeh',
    'category_id': '3axtyal4ge',
    'tag': 'Web'
  },
  'helpdocs': {
    'baseUrl': 'https://api-help.100px.com/api/wp/v2/',
    'api_key': '25qudf023lhz4aun2fyko3skj82h6e9p8n87uxeh',
    'category_id': '3axtyal4ge',
    'category': 'client',
    'tag': 'web',
    'voteUrl': 'https://api-help.100px.com/ajax/'
  },
  'GA_ACCOUNT': process.env.GA_ACCOUNT,
  'intercom': {
    'appId': process.env.INTERCOM_APPID
  },
  'maps': {
    providers: [
      {
        name: 'OpenStreetMap',
        visible: false,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 18,
        testTile: 'https://b.tile.openstreetmap.org/11/694/1236.png'
      },
      {
        name: 'Mapbox',
        visible: false,
        url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        options: {
          id: 'mapbox/light-v10',
          accessToken: process.env.MAPBOX_ACCESSTOKEN,
          tileSize: 512,
          zoomOffset: -1
        },
        testTile: 'https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/10/347/618?access_token=' + process.env.MAPBOX_ACCESSTOKEN
      },
      {
        name: 'CartoDB',
        visible: false,
        url: 'https://d1inm7pu94hsf0.cloudfront.net/{z}/{x}/{y}{r}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 18,
        testTile: 'https://d1inm7pu94hsf0.cloudfront.net/11/694/1236.png'
      }
    ],
    'api_key': 'AIzaSyCtLM5BMLwBLeiIx7QHWBy6JOvi0hVwiJo',
    'fromIcon': {
      'path': 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
      'fillColor': '#090',
      'fillOpacity': 1,
      'strokeColor': '#000',
      'strokeWeight': 2,
      'scale': 1
    },
    'staticMapStyle': [
      {
        'featureType': 'landscape',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'color': '#dadddf'
          },
          {
            'lightness': '60'
          }
        ]
      },
      {
        'featureType': 'landscape.natural',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#f2eee6'
          }
        ]
      },
      {
        'featureType': 'poi.attraction',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'poi.business',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'poi.government',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'poi.medical',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#dbe5ba'
          }
        ]
      },
      {
        'featureType': 'poi.park',
        'elementType': 'labels',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'poi.place_of_worship',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'poi.school',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'poi.sports_complex',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
          {
            'visibility': 'simplified'
          }
        ]
      },
      {
        'featureType': 'transit.line',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'simplified'
          }
        ]
      },
      {
        'featureType': 'transit.station',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'all',
        'stylers': [
          {
            'color': '#b5dbef'
          }
        ]
      }
    ]
  }
}
